<template>
  <div id="parking">
    <BarChart class="parking"
      :chartData="parkingChartData"
      :options="parkingChartOptions"
      />
  </div>
</template>

<script>
import BarChart from '../Surveys/BarChart'

export default {
  name: 'ParkingContext',
  components: {
    BarChart
  },
  props: {
    entityId: String,
    highlightDate: Object,
    parkingChartData: Object,
    chartMaxYAxis: Number,
  },
  data() {
    return {
      parkingChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'top',
          labels: {
            boxWidth: 0,
            fontColor: 'black'
          }
        },
        tooltips: {
          callbacks: {
            label: (item) => " Aantal beschikbare plekken: "+ item.yLabel,
          }
        },
        scales: {
          xAxes: [{
            display: true,
            type: 'time',
            time: {
                unit: 'day'
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              padding: 25,
              suggestedMax: this.chartMaxYAxis,
            },
            scaleLabel: {
              display: true,
              labelString: 'Aantal beschikbare plekken'
            }
          }]
        }
      }
    }
  }
}
</script>
